import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { Scadenza } from '../../../models/scadenza';

import { ScadenzaListRinviiConcreteFormComponent } from './scadenza-list-rinvii-concrete-form.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [modale_list_rinvii_scadenza]',
  templateUrl: 'scadenza-mod-list-rinvii.component.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class ScadenzaModListRinviiComponent {
  @Output() onReturn: EventEmitter<Scadenza> = new EventEmitter<Scadenza>();
  @ViewChild('formScadenzarioListRinvii') formScadenzarioListRinvii: ScadenzaListRinviiConcreteFormComponent;

  inizializza(scadenza: Scadenza) {
    this.formScadenzarioListRinvii.inizializza(scadenza.rinvioScadenza);
    openModal('modallistrinviiscad');
  }

  manageModal() {
      closeModal('modallistrinviiscad');
  }
}
